module.exports = __webpack_public_path__ + "img/users-alt.423ce48d.svg";